import {Layer} from "./Layer";
import {LayerImageRepository} from '../LayerImageRepository';
import ImageResolution from '../saunaparts/ImageResolution';
import { PanelMaterial } from '../saunaparts/PanelMaterial';

import { ColorLayer } from './ColorLayer';
 export class PanelLayer implements Layer {
    material: PanelMaterial;
    roomSize: string;
    imageRepository: LayerImageRepository;
    constructor(material: PanelMaterial, roomSize: string,imageRepository : LayerImageRepository) {
        this.material = material;
        this.roomSize = roomSize;
        this.imageRepository = imageRepository;
    }
    Render(desiredResolution: ImageResolution): Promise<HTMLCanvasElement> {
        let imagePath = this.imageRepository.getPanelLayer(this.material, this.roomSize, desiredResolution);
        let canvas = document.createElement("canvas");
        canvas.width=desiredResolution.width;
        canvas.height= desiredResolution.height;
        let context = canvas.getContext("2d")!!;
        return new ColorLayer(imagePath,this.material.color,context).Render(desiredResolution).then(()=>canvas);        

    }    
}
